
export class LinkedItem {  
linkedItemId:any
linkedItemNumber:any
linkedItemType!:number
}